<template>
	<div :class="{'mb-16': field.labelStyle=='extra-space'}">
        <span v-if="editing && field.conditional" class="badge badge-info">{{ $t('conditional') }}</span>
		<component
            v-if="shouldRender" 
            :is="component"
            :field="field"
            :editing="editing"
            :readonly="readonly || (!userCanCompleteField && !editing)"
            :viewAs="viewAs"
            @limit-exceeded="limitExceeded"
		/>
	</div>
</template>

<script>
export default {
	name: 'FormField',
	props: [
		'field',
		'type',
		'editing',
		'readonly',
		'viewAs',
		'formresponse',
        'required',
        'allFieldsById'
	],
	data() {
		return {
			component: null,
		};
	},
	watch: {
		type: function () {
			this.loader()
				.then(() => {
					this.component = () => this.loader()
				})
		}
	},
	mounted() {

		this.loader()
			.then(() => {
				this.component = () => this.loader()
			})
			/*.catch(() => {
				//this.component = () => import('templates/default')
			})*/

	},
    methods: {
        // getFieldValueById(fieldId) {
        //     return this.allFieldsById?.[fieldId]?.value;
        // }
        // getFieldValueById(fieldId) {
        //     if (!this.formresponse?.formresponse_data?.pages) return undefined;

        //     for (const page of this.formresponse.formresponse_data.pages) {
        //         for (const row of page.grid) {
        //             for (const col of row) {
        //             for (const field of col.fields) {
        //                 if (typeof field === 'object' && field !== null && !Array.isArray(field)) {
        //                     if (field.id == fieldId) {
        //                         return field.value;
        //                     }
        //                 }
        //             }
        //             }
        //         }
        //     }
        //     return undefined;
        // },
        getFieldValueById(fieldId){
            for (const field of this.previewFields) {
                if (typeof field === 'object' && field !== null && !Array.isArray(field)) {
                    if (field.id == fieldId) {
                        return field.value;
                    }
                }
            }
            return undefined
        },
        limitExceeded(payload){
            this.$emit("limit-exceeded", payload);
        }
    },
	computed: {
        loader() {
            if (!this.type) {
                return null
            }
            // 'grade' is a question-bank-flagged select field - same rendering as 'select',
            // just distinguishable as "this field belongs to the question bank" at the type level.
            const templatetype = this.type === 'grade' ? 'select' : this.type;
            return () => import(`./templates/${templatetype}`)
        },
		userCanCompleteField() {
			if(this.viewAs) {
				return  !('permission' in this.field) || this.field.permission.length == 0
				|| this.field.permission.includes(this.viewAs) || this.viewAs === 'editall'
			} else {
				return false
			}/*else {
				return this.field.permission === []
				|| (this.$UserSession.hasPriv('TREATMENTSESSION_MANAGE') && this.field.permission == 'submitter')
				|| (this.$UserSession.hasPriv('TREATMENTSESSION_MANAGE') && this.field.permission == 'reviewer')
				|| (this.$UserSession.hasPriv('TREATMENTSESSION_MANAGE') && this.field.permission == 'signer')
			}*/
		},
		userCanViewField() {
			return !this.field.hideifcantcomplete || this.userCanCompleteField || this.editing || (this.field.showaftersignoff && this.formresponse && this.formresponse.formresponse_signedoff == '1') ||  (this.field.showafterreview && this.formresponse && this.formresponse.formresponse_reviewed == '1');
		},
        conditionIsMet() {
            const cond = this.field?.conditional;
            if (!cond || !cond.dependsOn) return true;
            
            const targetValue = this.getFieldValueById(cond.dependsOn);
            if(!targetValue) console.warn("Can't get target value for ",cond.dependsOn)
            
            const { operator, value } = cond;
            switch (operator) {
                case 'equals':
                return targetValue === value;
                case 'notEquals':
                return targetValue !== value;
                case 'truthy':
                return targetValue != null && targetValue !== '' && 
                        !(Array.isArray(targetValue) && targetValue.length === 0);
                case 'falsy':
                return targetValue == null || targetValue === '' || 
                        (Array.isArray(targetValue) && targetValue.length === 0);
                default:
                return true;
            }
        },
        shouldRender() {
            return (this.editing || (this.userCanViewField && this.conditionIsMet))
        },
        previewFields(){
            return this.allFieldsById
        }
	},
};
</script>
